module.exports = __webpack_public_path__ + "img/result-image.8931eb53.png";